import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=2d551de2&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=2d551de2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d551de2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d551de2')) {
      api.createRecord('2d551de2', component.options)
    } else {
      api.reload('2d551de2', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=2d551de2&scoped=true", function () {
      api.rerender('2d551de2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/SurveyManage/Dashboard.vue"
export default component.exports